module.exports = __webpack_public_path__ + "img/Triste_Corpo_1.bf585ad4.png";